export const T = {
  en_GB: {
    total: "Total",
    perMonth: "/mo",
    fromAccounts: "Account",
    conversionUnavailable: "No exchange rate available — not included in totals",
    accountDataAsOf: "Account data as of",
  },
  nb_NO: {
    total: "Totalt",
    perMonth: "/mnd",
    fromAccounts: "Konto",
    conversionUnavailable: "Ingen valutakurs tilgjengelig — ikke medregnet i totalene",
    accountDataAsOf: "Kontodata per",
  },
} as const;
